module.exports = __webpack_public_path__ + "img/weixin.076c29ac.png";